import { Component } from '@angular/core'
import {
  AccountStoreService,
  HouseholdStoreService
} from '@se-po/se-household-setup-data-access-store'

@Component({
  selector: 'se-po-household-setup-docs',
  templateUrl: './se-household-setup-docs.component.html',
  styleUrls: ['./se-household-setup-docs.component.scss'],
  standalone: false,
})
export class SeHouseholdSetupDocsComponent {

  constructor(
    public accountStore: AccountStoreService,
    public householdStore: HouseholdStoreService,
  ) { }
}
